module.exports = __webpack_public_path__ + "k6.3_nXy17r.svg";